// config.js
export const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export const mapBoxToken = process.env.REACT_APP_MAPBOX_TOKEN;

export default backendUrl;